export default __webpack_public_path__ + "static/media/dashboard.e0fe9597.svg";